
import React, { createContext, useState } from "react";

export const ConfigurationContext = createContext();

export const ConfigurationContextProvider = props => {
  const [configurations, setConfigurations] = useState(null);
  
  return (
    <ConfigurationContext.Provider value={{ configurations, setConfigurations }}>
      {props.children}
    </ConfigurationContext.Provider>
  );
};
